import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { useSearchStore } from '@/pages/customs/stores/useSearchStore'
import { MasterBillSchema, MasterBillStatus } from '@/services/CustomsV2Service'

interface DevanningState {
  masterBill?: MasterBillSchema
  masterBills: MasterBillSchema[]
}

interface DevanningActions {
  loadMasterBills: () => Promise<void>
  setMasterBill: (id: number) => void
}

type DevanningStore = DevanningState & DevanningActions

const initialState: DevanningState = {
  masterBills: []
}

export const useDevanningStore = create<DevanningStore>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        loadMasterBills: async () => {
          // 获取更新后的 masterBills 数据
          // 调用 useSearchStore 的 fetchMasterBills 方法
          await useSearchStore.getState().fetchMasterBills()
          
          const masterBills = useSearchStore
            .getState()
            .masterBills.filter(
              (masterBill) => masterBill.status === MasterBillStatus.DEVANNING
            )
          set({ masterBills })

          if(masterBills.length === 1) {
            get().setMasterBill(masterBills[0].id)
          }

        },
        setMasterBill: (id) => {
          const activedMasterBill = get().masterBills.find(
            (masterBill) => masterBill.id === id
          )
          set({
            masterBill: activedMasterBill
          })
        }
      }),
      {
        name: 'devanning-storage',
        partialize: (state) => ({
          masterBill: state.masterBill,
          masterBills: state.masterBills
        })
      }
    )
  )
)

export const useDevanningState = () => {
  const masterBills = useDevanningStore((state) => state.masterBills)
  const masterBill = useDevanningStore((state) => state.masterBill)

  return {
    masterBills,
    masterBill
  }
}

export const useDevanningActions = () => {
  const loadMasterBills = useDevanningStore((state) => state.loadMasterBills)
  const setMasterBill = useDevanningStore((state) => state.setMasterBill)
  return {
    loadMasterBills,
    setMasterBill
  }
}
